module.exports = __webpack_public_path__ + "img/-LV4sSaquAhw0gfYQS8Q.9ff700e4.jpg";